"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignMessageException = exports.ParameterRequiredException = void 0;
const tslib_1 = require("tslib");
const ErrorCode_1 = tslib_1.__importDefault(require("./ErrorCode"));
class ParameterRequiredException extends Error {
    constructor(name) {
        super(`${name} is required`);
        this.code = ErrorCode_1.default.ParameterRequired;
    }
}
exports.ParameterRequiredException = ParameterRequiredException;
class SignMessageException extends Error {
    constructor() {
        super('Fail to sign the message');
        this.code = ErrorCode_1.default.SignMessageFailed;
    }
}
exports.SignMessageException = SignMessageException;
exports.default = {
    ParameterRequiredException,
    SignMessageException,
};
//# sourceMappingURL=common.js.map